import Menu from './components/Menu';
import Home from './pages/Home';
import React, { useEffect } from 'react';
import { IonApp, IonRouterOutlet, IonSplitPane, IonToast } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router-dom';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import Log from './pages/Log';
import Videos from './pages/Videos';
import VideoView from './pages/VideoView';
import { InitialSetup } from './pages/InitialSetup';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCheckIns, fetchStages, selectPilgrimage } from './features/pilgrimage/pilgrimageSlice';
import { fetchContent } from './features/content/contentSlice';
import { useOnline } from './app/use-online';
import Checkins from './pages/Checkins';
import About from './pages/About';
import Guidebook from './pages/Guidebook';
import { selectMode } from './features/log/logSlice';
import { selectUserName } from './features/user/userSlice';

const App: React.FC = () => {
  // load the content each time the app loads, if pilgrimage has been selected
  const pilgrimage = useSelector(selectPilgrimage),
    dispatch = useDispatch(),
    online = useOnline(),
    mode = useSelector(selectMode),
    userName = useSelector(selectUserName);

  useEffect(() => {
    if(online && pilgrimage?.id) {
      dispatch(fetchStages(pilgrimage.id));
      dispatch(fetchContent(pilgrimage.id));
      dispatch(fetchCheckIns(pilgrimage.id));
    }
  }, []);

  return (
    <IonApp>
      <IonReactRouter>
        <IonSplitPane contentId="main">
          <Menu />
          <IonRouterOutlet id="main">
            <Route path="/home" component={Home} exact />
            <Route path="/log" component={Log} exact />
            <Route path="/content" component={Videos} exact />
            <Route path="/content/:contentId" component={VideoView} exact />
            <Route path="/checkins" component={Checkins} exact />
            <Route path="/guidebook" component={Guidebook} exact />
            <Route path="/about" component={About} exact />
            <Redirect from="/" to="/home" exact />
          </IonRouterOutlet>
        </IonSplitPane>
      </IonReactRouter>
      <InitialSetup
        pilgrimage={pilgrimage}
        mode={mode}
        username={userName}
      />
      <IonToast
        isOpen={!online}
        message="You are not connected to the Internet. Some features of the app, like videos and maps, may be unavailable."
      />
    </IonApp>
  );
};

export default App;
